export default "__VITE_ASSET__CXCyzwKQ__"